export const useIsExpoRouterEnabled = () => true;
